import { observer } from "mobx-react";
import FontHeading4 from "../../../../../../components/fonts/font-heading4/font-heading4";
import RefundCalculator from "../refund-calculator/refund-calculator";
import RefundActions from "../refund-actions/refund-actions";
import "./refund-calculator-drawer-content.scss";
import RefundCalculatorStore from "../../../stores/refund-calculator-store";
import SuggestedRefund from "./suggested-refund/suggested-refund";
import { Button } from "../../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import RmaPageStore from "../../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";

interface IRefundCalculatorDrawerContentProps {
    calculatorStore: RefundCalculatorStore;
    rma: RmaPageStore;
    onCancelClick: () => void;
}

const RefundCalculatorDrawerContent: React.FC<IRefundCalculatorDrawerContentProps> = observer(({calculatorStore, rma, onCancelClick}) => {

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    const onApplyClick = () => {
        rmsMixpanelStore.trackEvent('d&_calculator_apply');
        calculatorStore.setActualRefundAmount(calculatorStore.getSuggestedRefund(), true);
    }

    return (
        <div className="refund-calculator-drawer-content">
            <div className="refund-calculator-container">
                <FontHeading4>{getTranslation('REFUND_CALCULATOR', pageScope)}</FontHeading4>
                <div className="refund-calculator">
                    <RefundCalculator calculatorStore={calculatorStore}/>
                </div>  
                <div className="suggested-refund-block">
                    <SuggestedRefund calculatorStore={calculatorStore}/>
                    <hr/>
                    <div className="apply-button">
                        <Button 
                            text={getTranslation('APPLY', pageScope)}  
                            variant={BUTTON_VARIANTS.PrimaryAccent} 
                            onClick={onApplyClick}
                            disabled={calculatorStore.getSuggestedRefund() < 0}
                        />
                    </div>
                </div> 
            </div> 
            <div className="refund-actions-container">
                <RefundActions calculatorStore={calculatorStore} onCancelClick={onCancelClick} rma={rma}/>
            </div>

        </div>    
    );
});

export default RefundCalculatorDrawerContent;